//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import customer from '@/customer'

export default {
  name: 'scanUnlock',
  data () {
    return {
      cid: 0,
      mid: 0,
      token: '',
      status: 'loading',
      message: '开锁中...',
      storeTitle: customer.name
    }
  },
  computed: {
    tokenKey () {
      return 'scan_token_' + customer.key
    },
  },
  created () {
    this.init()
  },
  methods: {
    init () {
      this.parseScene()
      if (!this.cid) {
        this.status = 'error'
        this.message = '二维码异常，缺少门店信息'
        return
      }
      this.openLock()
    },
    retry () {
      this.status = 'loading'
      this.message = '开锁中...'
      this.openLock()
    },
    parseScene () {
      const query = Object.assign({}, this.$route.query)
      const scene = query.scene ? decodeURIComponent(query.scene) : ''
      if (scene && scene !== 'undefined') {
        scene.split('&').forEach((item) => {
          const arr = item.split('=')
          if (arr[0]) {
            query[arr[0]] = arr[1]
          }
        })
      }
      this.cid = parseInt(query.cid || 0)
      this.mid = parseInt(query.mid || query.id || 0)
    },
    openLock () {
      this.status = 'loading'
      this.message = '开锁中...'
      const data = {cid: this.cid}
      if (this.mid) {
        data.id = this.mid
      }
      this.$api.scanOpenLock(data, this.token).then((res) => {
        if (!res) {
          this.status = 'error'
          this.message = '开锁失败，请稍后再试'
          return
        }
        if (res.code === 0) {
          this.status = 'success'
          this.message = res.msg || '已开锁'
          if (res.data && res.data.src) {
            const audio = new Audio(res.data.src)
            audio.play()
          }
          this.$api.scanOpenLockCallback({cid: this.cid}, this.token)
          return
        }
        this.status = 'error'
        this.message = res.msg || '开锁失败'
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/scanUnlock.vue